export default __webpack_public_path__ + "static/media/Quote2.56249c63.svg";